import { Component } from '@angular/core';

import { HeaderBaseComponent } from '@eview/features';

@Component({
  selector: 'eview-header',
  templateUrl: 'header.component.html'
})
export class HeaderComponent extends HeaderBaseComponent {}
